import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { ConvoService } from '../../../service/ConvoService'
import TYPES from '../../../config/Types'
import convoStore from '../convo-store'
import convoUtils from './convo-utils'
import { IConvo } from '../../../model/convo'
import { Meta } from '../../../model/meta'

export default async function fetchAllJybed(context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
  convoUtils.convoService.getIsJybed(convo).then((isAllJybed: Meta<boolean>) => {
    convoStore.commitSetIsAllJybed({ convo: convo, isAllJybed: isAllJybed.value })
  })

  return
}
